package com.kinoshazam.history

import kotlinx.browser.window
import org.w3c.dom.events.Event

actual fun browserHistoryPort(): BrowserHistoryPort? = JsBrowserHistory

private object JsBrowserHistory : BrowserHistoryPort {
    override fun capture(): BrowserLocation {
        val path = browserPath(window.location.pathname, window.location.search)
        return BrowserLocation(
            path = path,
            stateJson = historyStateJson(),
            isJoin = isJoinLocation(path),
        )
    }

    override fun push(path: String, stateJson: String) {
        window.history.pushState(stateJson, "", path)
    }

    override fun replace(path: String, stateJson: String) {
        window.history.replaceState(stateJson, "", path)
    }

    override fun back() {
        window.history.back()
    }

    override fun listen(onPop: (stateJson: String?) -> Unit): () -> Unit {
        val listener: (Event) -> Unit = {
            onPop(historyStateJson())
        }
        window.addEventListener("popstate", listener)
        return { window.removeEventListener("popstate", listener) }
    }
}

private fun browserPath(pathname: String, search: String): String {
    val path = when {
        pathname.isBlank() -> "/"
        pathname.length > 1 -> pathname.trimEnd('/')
        else -> pathname
    }
    return path + search
}

private fun historyStateJson(): String? {
    val state = window.history.state ?: return null
    val text = state as? String ?: state.toString()
    return text.takeIf { it.startsWith("{") }
}
